import React from "react";
// import { Link } from "react-router-dom";

export default function Completion({ data, onPrev, onFinish }) {
  return (
    <div className="space-y-6 py-4">
      <div className="space-y-2 text-center">
        <h2 className="text-2xl font-bold">
          Great! You're Almost there. Here's what's next:
        </h2>
        {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
      </div>
      <div className="space-y-4">
        <ol className="list-decimal space-y-2 pl-4">
          <li>Login with your email & password.</li>
          <li>Complete your Profile & Portfolio.</li>
          <li>Create your events and packages.</li>
          <li>Publish and look for events in your area.</li>
        </ol>
      </div>
      <div className="flex flex-row justify-end items-center mt-6">
        <button
          onClick={onFinish}
          className="bg-[#FF4C18] text-white px-6 py-2 rounded-lg font-semibold hover:bg-orange-600 transition-colors"
        >
          Finish
        </button>
      </div>
    </div>
  );
}
